import React, { useEffect, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect';
import { fetchMillReceives } from '../../app/api/millReceive';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import moment from 'moment';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import ChallanSelectPopup from './ChallanSelectPopup';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import SecondaryButton from '../../components/infrastructure/Buttons/SecondaryButton';
import { TableHeader } from '../../components/Table/TableHeader';
import ViewTakaDetails from './ViewTakaDetails';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchQualities,
    getQuality,
} from '../../app/reducers/Quality/qualitySlice';
import { parseToFloat } from '../../utils/Utils';
import * as Yup from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { createCuttingCard } from '../../app/api/CuttingCard';
import { ClipLoader } from 'react-spinners';

const CreateCuttingCard = () => {
    const tableHeader = [
        { name: 'Mill Name' },
        { name: 'Challan No' },
        { name: 'Lot No' },
        { name: 'quality' },
        { name: 'Weaver Name' },
        { name: 'Grey Challan No' },
        { name: 'Grey Meter' },
        { name: 'Mill Meter' },
        { name: 'Total Shortage' },
        { name: 'Cost Per M' },
        { name: 'View' },
    ];
    const computeShortage = (greyMt, millMt) => {
        console.log(greyMt, millMt, 'grey mill');
        if (parseFloat(greyMt) === 0) {
            return 0;
        }
        return parseToFloat(
            ((parseFloat(greyMt) - parseFloat(millMt)) * 100) /
                parseFloat(greyMt)
        );
    };
    const dispatch = useDispatch();
    const { quality } = useSelector(getQuality);
    const [challanSelectPopupOpen, setChallanSelectPopupOpen] = useState(false);
    const [viewTakaDetailsModalOpen, setViewTakaDetailsModalOpen] =
        useState(false);
    const [currentPoData, setCurrentPoData] = useState([]);
    const [currentTakaDetailsIndex, setCurrentTakaDetailsIndex] =
        useState(null);
    const formik = useFormik({
        initialValues: {
            millRecRef: '',
            gpNumber: '',
            millName: '',
            cut: '',
            notes: '',
            date: moment().valueOf(),
            poData: [
                // {
                //     broker: '',
                //     quality: '',
                //     greyPoRef: '',
                //     millPoRef: '',
                //     greyChallanNo: '',
                //     millChallanNo: '',
                //     weaverName: '',
                //     millName: '',
                //     lotNo: '',
                //     greyAmount: '',
                //     millAmount: '',
                //     costPerMeter: '',
                //     greyMeter: '',
                //     millMeter: '',
                //     totalShortage: '',
                //     takaDetails: [
                //         {
                //             takaId: '',
                //             greyMt: '',
                //             millMt: '',
                //             shortage: '',
                //             fresh: '',
                //             second: '',
                //             bestOutput: '',
                //         },
                //     ],
                // },
            ],
        },
        validationSchema: Yup.object({
            millRecRef: Yup.string().required(),
            gpNumber: Yup.string().required(),
            millName: Yup.string().required(),
            cut: Yup.string().required(),
            date: Yup.string().required(),
            poData: Yup.array(),
        }),
        onSubmit: async (values) => {
            try {
                console.log(values, 'formikValues');
                const resp = await createCuttingCard(values);
                console.log(resp.data);
                toast.success('Cutting Card generated');
                formik.resetForm();
            } catch (error) {
                console.log(error);
                toast.error('Failed to create cutting card');
            }
        },
    });
    useEffect(() => {
        dispatch(fetchQualities({ limit: 400 }));
    }, []);
    console.log(viewTakaDetailsModalOpen);
    return (
        <PageWithCard>
            <ChallanSelectPopup
                challanSelectPopupOpen={challanSelectPopupOpen}
                setChallanSelectPopupOpen={setChallanSelectPopupOpen}
                formik={formik}
                currentPoData={currentPoData}
                setCurrentPoData={setCurrentPoData}
            />
            <ViewTakaDetails
                viewTakaDetailsModalOpen={viewTakaDetailsModalOpen}
                setViewTakaDetailsModalOpen={setViewTakaDetailsModalOpen}
                currentTakaDetailsIndex={currentTakaDetailsIndex}
                setCurrentTakaDetailsIndex={setCurrentTakaDetailsIndex}
                formik={formik}
            />
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-4"
            >
                {formik.values.millRecRef ? (
                    <>
                        <div className="grid grid-cols-5 gap-2 items-end">
                            <FormikInputGroup
                                name={'gpNumber'}
                                formik={formik}
                                label="GP No"
                                readOnly
                            />

                            <FormikInputGroup
                                name={'millName'}
                                formik={formik}
                                label="Mill Name"
                                readOnly
                            />
                            <FormikInputGroup
                                name={'cut'}
                                formik={formik}
                                label="Cut"
                            />
                            <FormikInputDateGroup
                                name={'date'}
                                label="Date"
                                formik={formik}
                            />
                            <FormikInputGroup
                                formik={formik}
                                name="notes"
                                label="Notes"
                            />
                        </div>
                        <div>
                            <SecondaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setChallanSelectPopupOpen(true);
                                }}
                            >
                                Edit Data
                            </SecondaryButton>
                        </div>
                        <div className="overflow-auto">
                            <table className="w-full">
                                <TableHeader headers={tableHeader} />
                                <tbody>
                                    {formik.values.poData.map((ele, i) => (
                                        <tr>
                                            <td>{ele.millName}</td>
                                            <td>{ele.millChallanNo}</td>
                                            <td>{ele.lotNo}</td>
                                            <td>
                                                {
                                                    quality?.docs?.find(
                                                        (item) =>
                                                            item._id ===
                                                            ele.quality
                                                    )?.name
                                                }
                                            </td>
                                            <td>{ele.weaverName}</td>
                                            <td>{ele.greyChallanNo}</td>
                                            <td>
                                                {ele.greyMeter}({ele.greyRate})
                                            </td>
                                            <td>
                                                {ele.millMeter}({ele.millRate})
                                            </td>
                                            <td>{ele.totalShortage}</td>
                                            <td>{ele.costPerMeter}</td>
                                            <td>
                                                <div>
                                                    <SecondaryButton
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            console.log(
                                                                'clicked'
                                                            );
                                                            setViewTakaDetailsModalOpen(
                                                                true
                                                            );
                                                            setCurrentTakaDetailsIndex(
                                                                i
                                                            );
                                                        }}
                                                    >
                                                        View
                                                    </SecondaryButton>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <>
                        <FormikInputGroup
                            name={'cut'}
                            formik={formik}
                            label="Cut"
                        />
                        {formik.values.cut && (
                            <FormikAsyncSelect
                                label="Select GP"
                                getOptions={async (search) => {
                                    const searchPayload = {
                                        search,
                                    };
                                    const receiveResp =
                                        await fetchMillReceives(searchPayload);
                                    const options =
                                        receiveResp?.data?.docs?.length > 0
                                            ? receiveResp.data.docs.map(
                                                  (ele) => ({
                                                      label: `${ele.invoiceNo}/ ${ele.vendorName}`,
                                                      value: ele._id,
                                                  })
                                              )
                                            : [];
                                    return options;
                                }}
                                onChange={async (selectedOption) => {
                                    try {
                                        const fetchPayload = {
                                            _id: selectedOption.value,
                                            populate: true,
                                        };
                                        const gpResponse =
                                            await fetchMillReceives(
                                                fetchPayload
                                            );
                                        let receiveData =
                                            gpResponse.data.docs[0];
                                        receiveData.poData =
                                            receiveData.poData.filter(
                                                (item) =>
                                                    item.status !==
                                                    'cuttingCardGenerated'
                                            );
                                        console.log(
                                            receiveData,
                                            'mill receive'
                                        );
                                        formik.setFieldValue(
                                            'millRecRef',
                                            selectedOption.value
                                        );
                                        formik.setFieldValue(
                                            'gpNumber',
                                            receiveData.invoiceNo
                                        );
                                        formik.setFieldValue(
                                            'millName',
                                            receiveData.vendorName
                                        );
                                        const currentPoDataPayload =
                                            receiveData.poData.map((ele) => {
                                                const takaDetails = [];
                                                for (
                                                    let i = 0;
                                                    i < ele.takaDetails.length;
                                                    i++
                                                ) {
                                                    const element =
                                                        ele.takaDetails[i];
                                                    // console.log(
                                                    //     element,
                                                    //     'element'
                                                    // );
                                                    for (
                                                        let k = 0;
                                                        k <
                                                        element.receiveQuantity
                                                            .length;
                                                        k++
                                                    ) {
                                                        const receive =
                                                            element
                                                                .receiveQuantity[
                                                                k
                                                            ];
                                                        const bestOutput =
                                                            Math.floor(
                                                                parseFloat(
                                                                    receive.quantity
                                                                ) /
                                                                    parseFloat(
                                                                        formik
                                                                            .values
                                                                            .cut
                                                                    )
                                                            );
                                                        takaDetails.push({
                                                            takaId: receive.takaId,
                                                            greyMt:
                                                                k > 0
                                                                    ? 0
                                                                    : element.sendQuantity,
                                                            millMt: receive.quantity,
                                                            shortage:
                                                                computeShortage(
                                                                    k > 0
                                                                        ? 0
                                                                        : element.sendQuantity,
                                                                    receive.quantity
                                                                ),
                                                            second: '',
                                                            bestOutput:
                                                                bestOutput,
                                                        });
                                                    }
                                                }
                                                // const takaDetails =
                                                //     ele.takaDetails.map(
                                                //         (taka) => {
                                                //             const totalReceive =
                                                //                 taka.receiveQuantity.reduce(
                                                //                     (
                                                //                         acc,
                                                //                         item
                                                //                     ) =>
                                                //                         (acc +=
                                                //                             item.quantity),
                                                //                     0
                                                //                 );
                                                //             return {
                                                //                 takaId: taka.takaId,
                                                //                 greyMt: taka.sendQuantity,
                                                //                 millMt: totalReceive,
                                                //                 shortage: '',
                                                //                 fresh: '',
                                                //                 second: '',
                                                //                 bestOutput: '',
                                                //             };
                                                //         }
                                                //     );
                                                const greyAmount = parseToFloat(
                                                    parseFloat(
                                                        ele?.poId?.greyRate
                                                    ) * parseFloat(ele?.greyMt)
                                                );
                                                const millAmount = parseToFloat(
                                                    parseFloat(ele?.rate) *
                                                        parseFloat(ele?.finalMt)
                                                );
                                                const costPerMeter =
                                                    parseToFloat(
                                                        (greyAmount +
                                                            millAmount) /
                                                            ele?.finalMt
                                                    );
                                                return {
                                                    broker: ele?.greyPoRef
                                                        ?.brokerName,
                                                    quality:
                                                        ele?.greyPoRef?.quality,
                                                    greyPoRef:
                                                        ele?.greyPoRef?._id,
                                                    millPoRef: ele?.poId?._id,
                                                    greyChallanNo:
                                                        ele?.greyPoRef?.billNo,
                                                    millChallanNo:
                                                        ele?.poId?.challanNo,
                                                    weaverName:
                                                        ele?.greyPoRef
                                                            ?.vendorName,
                                                    millName:
                                                        ele?.poId?.vendorName,
                                                    lotNo: ele?.poId?.lotNo,
                                                    greyRate:
                                                        ele?.poId?.greyRate,
                                                    millRate: ele?.rate,
                                                    greyAmount: greyAmount,
                                                    millAmount: millAmount,
                                                    costPerMeter: costPerMeter,
                                                    greyMeter: ele?.greyMt,
                                                    millMeter: ele?.finalMt,
                                                    lotNo: ele?.lotNo,
                                                    totalShortage: parseToFloat(
                                                        ((ele.greyMt -
                                                            ele.finalMt) *
                                                            100) /
                                                            ele.greyMt
                                                    ),
                                                    takaDetails: takaDetails,
                                                };
                                            });
                                        setCurrentPoData(currentPoDataPayload);

                                        setChallanSelectPopupOpen(true);
                                    } catch (error) {
                                        toast.error(
                                            'error fetching mill receive'
                                        );
                                        console.log(error);
                                    }
                                }}
                                name="millRecRef"
                                formik={formik}
                            />
                        )}
                    </>
                )}
                <div>
                    {formik.isSubmitting ? (
                        <ClipLoader />
                    ) : (
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    )}
                </div>
            </form>
        </PageWithCard>
    );
};

export default CreateCuttingCard;
